import sourceErrorPage from './view/sourceError.html'
import { sourceError } from 'redevConfig'

const list = (sourceError && sourceError.list) || ''
const detail = (sourceError && sourceError.detail) || ''
const sourceErrorListPage = list ? require(`redevelopment/outputManage/sourceError/${list.templateName}`) : require('./view/sourceErrorList.html')
const detailSourceErrorPage = detail ? require(`redevelopment/outputManage/sourceError/${detail.templateName}`) : require('./view/detailSourceError.html')

export const sourceErrorRouter = {
    state: 'outputManage.FOManage.sourceError',
    config: {
        url: '/sourceError',
        template: sourceErrorPage,
        abstract: true,
        // controller: 'sourceErrorCtrl',
        title: '异常销售单',
        default: 'outputManage.FOManage.sourceError.list',
    },
}
export const sourceErrorListRouter = {
    state: 'outputManage.FOManage.sourceError.list',
    config: {
        url: '/list',
        template: sourceErrorListPage,
        controller: 'sourceErrorListCtrl',
    },
}
export const sourceErrorDetailRouter = {
    state: 'outputManage.FOManage.sourceError.detail',
    config: {
        url: '/detail/:billId',
        template: detailSourceErrorPage,
        controller: 'detailSourceErrorCtrl',
        title: '异常详情',
    },
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/sourceError/Routers.js